import '../../i18n';
import { t } from 'i18next'
import React, { useContext, useEffect, useState } from 'react'
import ItemSelectableSimple from '../../components/ItemSelectable/ItemSelectableSimple'
import './settings.css';
import SettingsContext from '../../context/SettingsContext/SettingsContext';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { CustomSelectComplex } from '../../components/CustomSelectComplex/CustomSelectComplex';
import { EnableOpennings } from '../../components/Settings/EnableOpennings';
import PrivateRoute from '../../components/PrivateRoute/PrivateRoute';
import { BuildingsManagement } from '../../components/Settings/BuildingManagement/BuildingsManagement';
import { NameOfBuildings } from '../../components/Settings/NameOfEntities/NameOfBuildings';
import { AreasManagement } from '../../components/Settings/AreasManagement/AreasManagement';
import { NameOfAreas } from '../../components/Settings/NameOfEntities/NameOfAreas';
import { PeopleToVisitManagement } from '../../components/Settings/PeopleToVisitManagement/PeopleToVisitManagement';
import { SectorsManagement } from '../../components/Settings/Sectors/SectorsManagement';
import { AmountOfPeopleToVisit } from '../../components/Settings/AmountOfPeopleToVisit/AmountOfPeopleToVisit';
import ItemSelectableWithSwitch from '../../components/ItemSelectable/ItemSelectableWithSwitch';
import { Spinner } from 'reactstrap';
import EquipmentOrToolsTypes from '../../components/Settings/EquipmentOrToolsTypes/EquipmentOrToolsTypes';
import { getSettingMenuService } from '../../services/Settings';

export const Settings = () => {

    const navigate = useNavigate();
    const { pathname } = useLocation();
    const params = useParams();

    const { param1, param2, param3 } = params;
    const paramCount = Object.keys(params).length;

    useEffect(() => {
        const getMenu = async () => {
            const menu = await getSettingMenuService();
            localStorage.setItem('settingMenu', JSON.stringify(menu.data.response));
        }
        if (pathname === '/settings') {
            getMenu();
        }
    }, [pathname]);

    const localMenu = JSON.parse(localStorage.getItem('settingMenu'));

    const addTranslationsToMenu = (obj) => {
        // Verificar si el objeto es un array
        if (Array.isArray(obj)) {
            // Recorrer los elementos del array y aplicar la función de formato a cada uno
            return obj.map((item) => addTranslationsToMenu(item));
        }

        // Verificar si el objeto es un objeto
        if (typeof obj === 'object' && obj !== null) {
            // Crear un nuevo objeto para almacenar los valores formateados
            const formattedObj = {};

            // Recorrer las propiedades del objeto
            for (let key in obj) {
                // Verificar si la propiedad es "navName", "title" o "subtitle"
                if (['navName', 'title', 'subtitle'].includes(key)) {
                    // Formatear el valor de la propiedad y asignarlo al nuevo objeto
                    formattedObj[key] = t(obj[key]);
                } else {
                    // Si no es una de las propiedades específicas, copiar el valor sin formato al nuevo objeto
                    formattedObj[key] = addTranslationsToMenu(obj[key]);
                }
            }

            return formattedObj;
        }

        // Si el objeto no es un array ni un objeto, devolverlo sin cambios
        return obj;
    }

    const menu = addTranslationsToMenu(localMenu);

    const { settingsState, getSwitchesValues, setSetting, setFilterName, setSection } = useContext(SettingsContext);
    const { showSection, switches, isFetching } = settingsState;

    const [optionsToFilter, setOptionsToFilter] = useState([]);
    const [optionsToFilterOnlySwitches, setOptionsToFilterOnlySwitches] = useState([]);
    const [filterSectionName, setFilterSectionName] = useState('');

    const onlySections = showSection.switches?.length > 0 && showSection.sections?.length === 0;

    const getSectionsToSelect = (obj) => {
        const results = [];

        const searchKey = (obj) => {
            if (obj.key) {
                results.push({ label: `${obj.title} (${obj.navName})`, value: obj.routeAccess, key: obj.title });
            }

            if (obj.sections && Array.isArray(obj.sections)) {
                obj.sections.forEach((section) => {
                    searchKey(section);
                });
            }

            if (obj.switches && Array.isArray(obj.switches)) {
                obj.switches.forEach((option) => {
                    results.push({ label: `${option.title} (${option.navName})`, value: option.routeAccess, key: option.title });
                });
            }
        }

        searchKey(obj);

        return results;
    }

    const loadOptionsToFilter = () => {
        const options = getSectionsToSelect(menu);
        setOptionsToFilter(options);
    }

    const searchSectionByParams = () => {
        let sectionFiltered;
        let sectionFound;
        if (param1 && param2 && param3) {
            sectionFiltered = menu.sections.find((el) => el.key === param1);
            sectionFiltered = sectionFiltered.sections.find((el) => el.key === param2);
            sectionFound = sectionFiltered.sections.find((el) => el.key === param3)
            return setSection(sectionFound);
        }
        if (param1 && param2) {
            sectionFiltered = menu.sections.find((el) => el.key === param1);
            sectionFound = sectionFiltered.sections.find((el) => el.key === param2)
            return setSection(sectionFound);
        }
        if (param1) {
            sectionFound = menu.sections.find((el) => el.key === param1);
            return setSection(sectionFound);
        }
        sectionFound = menu;
        return setSection(sectionFound);
    }

    const routesWithoutConfigSearcher = [
        '/settings/params/nameOfEntities/buildingDescription',
        '/settings/params/nameOfEntities/areaDescription',
        '/settings/entityManagment/sectorMaganagement',
        '/settings/entityManagment/equipmentOrToolsMaganagement',
        '/settings/entityManagment/peopleToVisitMaganagement',
        '/settings/entityManagment/buildingsMaganagement',
        '/settings/entityManagment/areasMaganagement',
        '/settings/entityManagment/enableOpennings',
        '/settings/params/mandatoryInfo',
        '/settings/params/preferences/amountOfPeopleToVisitMaganagement'
    ]

    const filterSwitches = (value) => {
        setFilterSectionName(value);
        if (switches.length) {
            value = value.toLowerCase();
            const filteredObjects = switches.filter((opt) => {
                return opt.title.toLowerCase().includes(value);
            });
            return setOptionsToFilterOnlySwitches(filteredObjects);
        }
    }

    const componentDependRoute = {
        params: {
            mandatoryInfo: {},
            preferences: {
                amountOfPeopleToVisitMaganagement:
                    <PrivateRoute
                        permissions={[20]}
                        redirectTo='/settings/params/preferences'
                    >
                        <AmountOfPeopleToVisit />
                    </PrivateRoute>,
            },
            nameOfEntities: {
                buildingDescription:
                    <PrivateRoute
                        permissions={[15]}
                        redirectTo='/settings/params'
                    >
                        <NameOfBuildings />
                    </PrivateRoute>
                ,
                areaDescription:
                    <PrivateRoute
                        permissions={[15]}
                        redirectTo='/settings/params'
                    >
                        <NameOfAreas />
                    </PrivateRoute>
                ,
            }
        },
        entityManagment: {
            enableOpennings:
                <PrivateRoute
                    permissions={[9]}
                    redirectTo='/settings/entityManagment'
                >
                    <EnableOpennings />
                </PrivateRoute >
            ,
            buildingsMaganagement:
                <PrivateRoute
                    permissions={[14]}
                    redirectTo='/settings/entityManagment'
                >
                    <BuildingsManagement />
                </PrivateRoute>
            ,
            areasMaganagement:
                <PrivateRoute
                    permissions={[14]}
                    redirectTo='/settings/entityManagment'
                >
                    <AreasManagement />
                </PrivateRoute>
            ,
            peopleToVisitMaganagement:
                <PrivateRoute
                    permissions={[14]}
                    redirectTo='/settings/entityManagment'
                >
                    <PeopleToVisitManagement />
                </PrivateRoute>
            ,
            sectorMaganagement:
                <PrivateRoute
                    permissions={[14]}
                    redirectTo='/settings/entityManagment'
                >
                    <SectorsManagement />
                </PrivateRoute>
            ,
            equipmentOrToolsMaganagement:
                <PrivateRoute
                    permissions={[21]}
                    redirectTo='/settings/entityManagment'
                >
                    <EquipmentOrToolsTypes />
                </PrivateRoute>
            ,
        }
    }

    const navigateAnOtherSection = (section) => {
        setFilterName('');
        navigate(section);
    }

    const checkToRenderingComponent = (component) => {
        const notRenderingWithTwoParams = ['nameOfEntities', 'mandatoryInfo', 'preferences'];
        const notRenderingWithThreeParams = ['nameOfEntities'];
        const notRenderingWithOneParam = ['params', 'entityManagment'];

        if (
            (paramCount === 3 && !notRenderingWithThreeParams.includes(param3)) ||
            (paramCount === 2 && !notRenderingWithTwoParams.includes(param2)) ||
            (paramCount === 1 && !notRenderingWithOneParam.includes(param1))
        ) {
            return component;
        }

        return null;
    };

    const handleChange = async (key, value) => {
        await setSetting({ keyword: key, setting_value: value });
    }

    useEffect(() => {
        searchSectionByParams();
        loadOptionsToFilter();
        // eslint-disable-next-line
    }, [param1, param2, param3])

    useEffect(() => {
        if (showSection?.switches?.length) {
            getSwitchesValues();
        }
        // eslint-disable-next-line
    }, [showSection]);

    useEffect(() => {
        setOptionsToFilterOnlySwitches(switches);
        // eslint-disable-next-line
    }, [switches])

    return (
        <div className='ms-sm-0 me-sm-0 ms-3 me-3 h-100 d-flex flex-column'>

            {/*  searcher of switch only */}
            {onlySections && (
                <div className='mt-2 mb-2'>
                    <input
                        placeholder={t('SEARCH')}
                        type={"text"}
                        name={'searchOpennings'}
                        className="form-control access-input"
                        autoComplete='off'
                        value={filterSectionName}
                        onChange={(e) => filterSwitches(e.target.value)}
                    />
                </div>

            )}

            {/* searcher of sections only */}

            {!routesWithoutConfigSearcher.includes(pathname) && (
                <div className='mt-2 mb-2'>
                    <CustomSelectComplex
                        placeholder={t('SEARCH')}
                        options={optionsToFilter}
                        value=''
                        onChange={(e) => {
                            setFilterName(e.key);
                            navigate(e.value);
                        }}
                        isSearch
                        name='searchConfig'
                    />
                </div>
            )}


            {/*  Sections of Menu*/}
            {(showSection.sections?.length > 0) && (
                showSection.sections?.map((section, i) =>
                    <div
                        key={i}
                        className="mb-2"
                    >
                        <ItemSelectableSimple
                            onClick={() => navigateAnOtherSection(section.key)}
                        >
                            <div>
                                <p className='m-0 param-section-title'>{section.title}</p>
                                <p className='m-0 param-section-subtitle'>{section.subtitle}</p>
                            </div>
                        </ItemSelectableSimple>
                    </div>
                )
            )}

            {isFetching && (
                <div className="d-flex mt-4 justify-content-center">
                    <Spinner />
                </div>
            )}

            {/*  Switches of Menu */}
            {(showSection?.switches?.length > 0) && (
                <div className='itemsList'>
                    {(optionsToFilterOnlySwitches.length > 0) && (
                        optionsToFilterOnlySwitches.map((opt, i) =>
                            <div key={i} className='mb-2'>
                                <ItemSelectableWithSwitch checked={Number(opt.setting_value)} onChange={() => handleChange(opt.key, !Number(opt.setting_value))}>
                                    <div>
                                        <p className='m-0 param-section-title'>{opt.title}</p>
                                        <p className='m-0 param-section-subtitle'>{opt.subtitle}</p>
                                    </div>
                                </ItemSelectableWithSwitch>
                            </div>
                        )
                    )}
                </div>
            )}

            {/* render components */}

            {(paramCount === 3) && (
                checkToRenderingComponent(componentDependRoute[param1][param2][param3])
            )}
            {(paramCount === 2) && (
                checkToRenderingComponent(componentDependRoute[param1][param2])
            )}
            {(paramCount === 1) && (
                checkToRenderingComponent(componentDependRoute[param1])
            )}
        </div >
    )
}
